import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import RegistrationInfo from './RegistrationInfo';
import PersonalDetailsBike from './PersonalDetailsBike';
import PolicyDetails from './PolicyDetails';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import Cookies from 'js-cookie';
import apiUrls from '../../Api/MainApi';
import Swal from 'sweetalert2';
import CarDetails from './CarDetails';
import { convertDate, convertFormatMonth, generateRandomID } from '../../Utils/utils';
import LionIcon from "../../Assets/Images/bpn/iconLogoLion.png";

// import './CarFormStart.css'; // Import CSS file

function CarFormStart() {
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [data, setData] = useState({});
    const [isNextDisabled, setIsNextDisabled] = useState(true);
    const [personalInfoError, setPersonalInfoError] = useState(true);
    const [proceed, setProceed] = useState(true)
    const [isNextVisible, setIsNextVisible] = useState(false)
    const [vehicleError, setVehicleError] = useState('Please enter a valid vehicle registration number (e.g., XX12XX1234)');
    const [formTitles, setFormTitles] = useState(["Registration Information", "Car Details", "Policy Details", "Get Quote"]);
    const [formData, setFormData] = useState({
        registrationInfo: 2,
        registrationNumber: '',
        registrationLocation: null,
        registrationDate: '',
        make: null,
        makeLabel: null,
        modelLabel: null,
        makeSearch: "",
        modelSearch: " ",
        variantSearch: "",
        model: null,
        year: null,
        fuel: null,
        variant: null,
        policy: null,
        previousPolicy: null,
        previousInsurer: null,
        previousClaims: null,
        previousPolicyExpiryDate: null,
        ClaimInLastYear: null,
        date: '',
        ncb: 180784,
        name: '',
        email: '',
        number: '',
        pincode: ''
    });

    useEffect(() => {
        if (formData.registrationInfo === 1 || formData.registrationInfo === 2) {
            setFormData(prev => ({
                ...prev,
                make: null,
                model: null,
                variant: null,
                fuel: null,
                year: null,
                makeSearch: "",
                modelSearch: " ",
                registrationNumber: null
            }))
        }
    }, [formData.registrationInfo])
    useEffect(() => {
        if (formData.registrationInfo === 2 && page === 0) {
            setIsNextVisible(true)
        }
        else {
            setIsNextVisible(false)
        }
    }, [formData, page])
    useEffect(() => {
        const registrationNumberRegex = /^[A-Z]{2}\d{2}[A-Z]{1,2}\d{4}$/;
        if (page === 0 && formData.registrationInfo === 1 && formData.registrationLocation) {
            setIsNextDisabled(false);
        } else if (page === 0 && formData.registrationInfo === 2 && registrationNumberRegex.test(formData.registrationNumber)) {
            setIsNextDisabled(true);
            setProceed(false);
        } else if (page === 1 && formData.model && formData.year && formData.fuel && formData.variant) {
            setIsNextDisabled(false);
        }
        else if (page === 2 && formData.previousPolicy && formData.previousInsurer && formData.previousPolicyExpiryDate && formData.previousClaims) {
            setIsNextDisabled(false);
        }
        else if (page === 3 && personalInfoError === false) {
            setIsNextDisabled(false);
        }
        else {
            setIsNextDisabled(true); // Disable next button if none of the conditions are met
            setProceed(true);
        }
    }, [
        formData, page, personalInfoError
    ]);

    // Function to handle next button click
    const handleNextButtonClick = () => {
        if (isNextDisabled === true) {
            toast.error('Please enter the valid data.', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else {
            const cookieData = JSON.stringify(formData)
            Cookies.set("CarFormData", cookieData, { expires: 30 })
            setPage((currPage) => currPage + 1);
        }
    };
    // Function to handle previous button click
    const handlePrevButtonClick = () => {
        if (formData.registrationInfo === 1 && page === 3) {
            setPage(1);
        } else {
            // Otherwise, decrement page normally
            setPage((currPage) => currPage - 1);
        }
    };
    // Function to handle submission
    const handleSubmit = async () => {
        if (isNextDisabled === false) {
            // console.log(formData.previousPolicyExpiryDate , "line 132" , 23)
            var formattedStartDate = '';
            var formattedEndDate = '';

            if (formData.registrationInfo === 2) {
                const previousExpiryDate = convertFormatMonth(formData.previousPolicyExpiryDate)   // this line is to convert the format from dd-mm-yyyy to mm-dd-yyyy
                const previousPolicyExpiryDate = new Date(previousExpiryDate);
                const nextDay = new Date(previousPolicyExpiryDate);
                nextDay.setDate(previousPolicyExpiryDate.getDate() + 1);
                const nextYear = new Date();
                nextYear.setFullYear(nextDay.getFullYear() + 1);
                // Format the dates as desired, e.g., YYYY-MM-DD
                formattedStartDate = nextDay.toISOString().split('T')[0];
                formattedEndDate = nextYear.toISOString().split('T')[0];


            }
            else {
                const today = new Date();
                const nextYear = new Date(today);
                nextYear.setFullYear(today.getFullYear() + 3); // Add 1 year to today
                formattedStartDate = today.toISOString().split('T')[0];
                formattedEndDate = nextYear.toISOString().split('T')[0];
            }
            // generate the new enquiryID
            const enquiryID = generateRandomID(12);

            const sessionData = {     //////// to store the data for edit details
                "rto": formData.registrationLocation,
                "make": formData.make,
                "model": formData.model,
                "year": formData.year,
                "fuel": formData.fuel,
                "variant": formData.variant,
                "registrationDate": formData.registrationDate,
                "policy": formData.policy,
                "previousPolicy": formData.previousPolicy,
                "previousInsurer": formData.previousInsurer,
                "makeLabel": formData.makeLabel,
                "modelLabel": formData.modelLabel,
                "ncb": formData.ncb,
                "previousPolicyExpiryDate": formData.previousPolicyExpiryDate,
                "previousClaims": formData.previousClaims,
                "registrationNUmber": formData.registrationNumber,
                manufactureDate: formData.year
            }

            const quoteRequest = {
                pincode: formData.pincode,
                previousInsurerCode: "159",
                previousPolicyExpiryDate: formData.registrationInfo === 2 ? formData.previousPolicyExpiryDate : "null",
                isClaimInLastYear: formData.registrationInfo === 2 ? formData.previousClaims : false,
                NCBID: formData.ncb,
                previousPolicyNumber: null,
                isPreviousInsurerKnown: formData.registrationInfo === 2 ? true : false,
                originalPreviousPolicyType: null,
                previousPolicyType: null,
                currentThirdPartyPolicy: null,
                isPreInspectionOpted: false,
                policyHolderType: "INDIVIDUAL",
                insuranceProductCode: "",
                endDate: formattedEndDate,
                externalPolicyNumber: null,
                isNCBTransfer: false,
                subInsuranceProductCode: null,
                isIMT23: false,
                selection: false,
                voluntaryDeductible: null,
                isGeoExt: false,
                isTPPD: false,
                isOverturningExclusionIMT47: false,
                isTheftAndConversionRiskIMT43: false,
                userSpecialDiscountPercent: null,
                startDate: formattedStartDate,  // take the date dynamically
                isPOSP: false,
                isVehicleNew: formData.registrationInfo === 2 ? false : true,
                vehicleMaincode: "",
                licensePlateNumber: formData.registrationNumber ? formData.registrationNumber : "MH04",
                vehicleIdentificationNumber: "",
                engineNumber: "",
                enquiryId: enquiryID,
                manufactureDate: formData.year,
                registrationDate: formData.registrationInfo === 2 ? formData.registrationDate : null,
                MakeID: formData.make,
                ModelID: formData.model,
                VariantID: formData.variant,
                InsurerProductID: formData.policy,
                PreviousPolicyTypeID: formData.previousPolicy,
                InsurerID: 27,
                VehicleType: "Car",
                PreviousInsurerID: formData.previousInsurer,
                currentThirdPartyPolicyExpiryDateTime: formData.registrationInfo === 2 ? formattedEndDate : null,
                currentThirdPartyPolicyStartDateTime: formData.registrationInfo === 2 ? formattedStartDate : null,
                BusinessTypeName: formData.registrationInfo === 2 ? "Rollover" : "New",
                ProductName: "Motor",
                RTO: formData.registrationLocation ? formData.registrationLocation : null,
                // addons will be added after this
                cngSelection: false,
                consumablesSelection: false,
                engineProtectionSelection: false,
                keyAndLockProtectSelection: false,
                partsDepreciationSelection: false,
                personalBelongingSelection: false,
                returnToInvoiceSelection: false,
                rimProtectionSelection: false,
                roadSideAssistanceSelection: false,
                //accessories
                tyreProtectionSelection: false,
                electricalSelection: false,
                nonElectricalSelection: false,
                // legal liabilities
                cleanersLLSelection: false,
                employeesLLSelection: false,
                nonFarePaxLLSelection: false,
                paidDriverLLSelection: false,
                unnamedPaxLLSelection: false,
                workersCompensationLLSelection: false,
                // unNamed Pa
                unnamedCleanerSelection: false,
                unnamedConductorSelection: false,
                unnamedHirerSelection: false,
                unnamedPaidDriverSelection: false,
                unnamedPaxSelection: false,
                unnamedPillionRiderSelection: false,
            }
            sessionStorage.setItem("CarDetails", JSON.stringify(sessionData))
            sessionStorage.setItem("CarQuotationRequest", JSON.stringify(quoteRequest))
            /////////////////// api
            const leadDetails = {        //////to store the details for leads
                PolicyType: 180799,
                CustomerName: formData.name,
                MobileNo: formData.number,
                EmailID: formData.email,
                DOB: '',
                Gender: '',
                QuoteLeadJson: JSON.stringify(formData),
                Pincode: formData.pincode,
                LeadFromNo: 180798,
                CreatedBy: 1,
                IsActive: 1
            };
            const leadResponse = await axios.post(apiUrls.InsertLeadMaster, leadDetails)
            if (leadResponse.data.status === 0) {
                sessionStorage.setItem("CarLeadID", leadResponse.data.data)
                console.log(leadResponse)
                navigate(`${process.env.PUBLIC_URL}/motor-insurance/car-policy-list`);
            } else {
                Swal.fire({
                    title: "Oops",
                    text: "Something went wrong",
                    icon: "error"
                }).then((result) => {
                    // Check if the user clicked the "OK" button
                    if (result.isConfirmed) {
                        window.location.href = `${process.env.PUBLIC_URL}/`;
                    }
                });
            }
        } else {
            toast.error('Please enter the valid data.', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };
    const PageDisplay = () => {
        if (page === 0) {
            return <RegistrationInfo
                setPage={setPage}
                formData={formData}
                setFormData={setFormData}
                vehicleError={vehicleError}
                isNextDisabled={isNextDisabled}
                proceed={proceed}
            />;
        }
        if (formData.registrationInfo === 1) {
            if (page === 1) {
                return <CarDetails
                    data={data}
                    setData={setData}
                    formData={formData}
                    setFormData={setFormData}
                />; // Render page 2
            }
            // If registrationInfo is 1, skip page 2 and directly render page 3
            if (page === 2) {
                setPage(3); // Render page 3 directly
            }
            if (page === 3) {
                return <PersonalDetailsBike
                    formData={formData}
                    setFormData={setFormData}
                    setPersonalInfoError={setPersonalInfoError}
                />; // Render page 4
            }
        } else {
            // If registrationInfo is not 1, render pages as usual
            if (page === 1) {
                return <CarDetails
                    data={data}
                    setData={setData}
                    formData={formData}
                    setFormData={setFormData}
                />; // Render page 2
            }
            if (page === 2) {
                return <PolicyDetails
                    data={data}
                    setData={setData}
                    formData={formData}
                    setFormData={setFormData}
                />; // Render page 3
            }
            if (page === 3) {
                return <PersonalDetailsBike
                    formData={formData}
                    setFormData={setFormData}
                    setPersonalInfoError={setPersonalInfoError}
                />; // Render page 4
            }
        }
    };
    useEffect(() => {
        console.log(formData, "line 225")
    }, [formData])

    useEffect(() => {
        const cookiesData = Cookies.get("CarFormData");
        if (cookiesData) {
            const data = JSON.parse(cookiesData);
        }
    }, [])
    const progressWidth = ((page + 1) / formTitles.length) * 100 + "%";


    return (
        <>
            <div className='container'>
                <div className='main-form mb-5 mt-5'>
                    <Card>
                        <Card.Body style={{ padding: "5px 17px" }}>
                            <div className='row common-height-for-cards' >
                                <div className='loin-main-div col-md-4 col-sm-12'>
                                    <div className="header text-start px-5 mt-4 text-white ">
                                        <h2>{formTitles[page]}</h2>
                                    </div>
                                    <img src={LionIcon} alt="Lion Icon" />
                                </div>
                                <div className='display-box-and-buttons col-md-7 col-sm-12'>
                                    {PageDisplay()}
                                    <div className='button-container '>
                                        {page > 0 && (
                                            <button
                                                className='posp-back-button'
                                                onClick={handlePrevButtonClick}
                                            >
                                                <svg height="16" width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1024 1024"><path d="M874.690416 495.52477c0 11.2973-9.168824 20.466124-20.466124 20.466124l-604.773963 0 188.083679 188.083679c7.992021 7.992021 7.992021 20.947078 0 28.939099-4.001127 3.990894-9.240455 5.996574-14.46955 5.996574-5.239328 0-10.478655-1.995447-14.479783-5.996574l-223.00912-223.00912c-3.837398-3.837398-5.996574-9.046027-5.996574-14.46955 0-5.433756 2.159176-10.632151 5.996574-14.46955l223.019353-223.029586c7.992021-7.992021 20.957311-7.992021 28.949332 0 7.992021 8.002254 7.992021 20.957311 0 28.949332l-188.073446 188.073446 604.753497 0C865.521592 475.058646 874.690416 484.217237 874.690416 495.52477z"></path></svg>
                                                <span style={{ color: 'black' }}>Back</span>
                                            </button>
                                        )}
                                        {page === formTitles.length - 1 ? (
                                            <button className='posp-next-button' onClick={handleSubmit}>Submit</button>
                                        ) : (
                                            <>
                                                {!isNextVisible && (
                                                    <button type='button' className='posp-next-button' onClick={handleNextButtonClick}>
                                                        <span style={{ color: '#fff' }}>Next</span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"></path>
                                                        </svg>
                                                    </button>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </div>
            <ToastContainer />
        </>
    );
}

export default CarFormStart;
